import { Platform } from 'react-native'

export const IS_ANDROID = Platform.OS === 'android'
export const IS_IOS = Platform.OS === 'ios'
export const IS_WEB = Platform.OS === 'web'
export const IS_SERVER = typeof window === 'undefined'
export const SEARCH_AGE_MAX = 120
export const SEARCH_AGE_MIN = 18
export const SEARCH_AGE_MAX_DEFAULT = 100
export const SEARCH_MAX_DISTANCE_DEFAULT_KM = 80
export const SEARCH_MAX_DISTANCE_DEFAULT_MI = 50
export const SEARCH_MAX_DISTANCE_MAX_KM = 800
export const SEARCH_MAX_DISTANCE_MAX_MI = 500
export const SEARCH_MAX_DISTANCE_MIN_KM = 8
export const SEARCH_MAX_DISTANCE_MIN_MI = 5
export const PROFILE_PHOTOS_BUCKET = 'profile_photos'
export const PROFILE_PHOTOS_MAX = 6
export const PROFILE_PHOTOS_MIN = 4
export const VERIFICATION_PHOTOS_BUCKET = 'verification_photos'
export const VERIFICATION_PHOTOS_MIN = 3
export const IMAGE_WIDTH_MAX = 1080
export const HEIGHT_MIN = 61
export const HEIGHT_MAX = 275
export const HEIGHT_MID = 168
export const MOBILE_BREAKPOINT = 768
export const DESKTOP_BREAKPOINT = 1024
export const SIDEBAR_WIDTH = 224
export const HEADER_HEIGHT = 60
export const PROFILE_BIOGRAPHY_MIN = 2
export const PROFILE_BIOGRAPHY_MAX = 1500
export const PROFILE_CLOSEST_CITY_MAX = 50
export const PROFILE_INSTAGRAM_MAX = 50
export const PROFILE_OCCUPATION_MAX = 50
export const PROFILE_SCHOOL_MAX = 50
export const PROFILE_OTHER_MIN = 2
export const PROFILE_GENDER_OTHER_MAX = 30
export const PROFILE_DEET_OTHER_MAX = 50
export const PHOTO_DESCRIPTION_MAX = 500
export const PROFILE_PROMPTS_MAX = 3
export const PROFILE_PROMPT_ANSWER_MAX = 280
